// extracted by mini-css-extract-plugin
module.exports = {"actions":"t8AeeS2d-MwsUGXOsYGHng==","showResults":"VSFjLVzFI5lxz4GXXE9vGA==","choices":"ZNk71-N0ZU21r3d+OGdMZA=="};